import { render, staticRenderFns } from "./PharmaceuticalCareList.vue?vue&type=template&id=77afd3e0&scoped=true&"
import script from "./PharmaceuticalCareList.vue?vue&type=script&lang=js&"
export * from "./PharmaceuticalCareList.vue?vue&type=script&lang=js&"
import style0 from "./PharmaceuticalCareList.vue?vue&type=style&index=0&id=77afd3e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77afd3e0",
  null
  
)

export default component.exports